var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('i',{staticClass:"ic ic-help"}),_c('span',{staticClass:"hide-access"},[_vm._v(_vm._s(_vm.Translator('soprasolar.project.help')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }